<template>
<!--  unique-opened-->
<!--  #040728-->
  <div id="left-main" style="overflow: hidden; ">
    <div class="left" style="overflow: auto">
      <div class="left-content">
        <el-row >
          <el-col>
            <el-menu
              default-active="1"
              class="el-menu-vertical-demo"
              background-color="#00294F"
              text-color="#fff"
              active-text-color="#ffd04b">

              <el-menu-item index="1"  @click="selectOption(1)">
                <i class="el-icon-menu"></i>
                <span slot="title">设备概括</span>
              </el-menu-item>

              <el-submenu index="2">
                <template slot="title">
                  <img src="../img/mete.png">
                  <span>气象监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="2-1"  @click="selectOption(2)">实时数据</el-menu-item>
                  <el-menu-item index="2-2"  @click="selectOption(3)">历史数据</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="5">
                <template slot="title">
                  <img src="../img/soil.png"/>
                  <span>墒情监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="5-1"  @click="selectOption(11)">实时数据</el-menu-item>
                  <el-menu-item index="5-2"  @click="selectOption(12)">历史数据</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="3">
                <template slot="title">
                  <img src="../img/bug.png">
                  <span>虫情监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="3-1"  @click="selectOption(4)">实时数据</el-menu-item>
                  <el-menu-item index="3-2"  @click="selectOption(5)">图片分析</el-menu-item>
                  <el-menu-item index="3-3"  @click="selectOption(6)">区域虫情</el-menu-item>
<!--                  <el-menu-item index="3-4"  @click="selectOption(7)">虫情趋势</el-menu-item>-->
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="4">
                <template slot="title">
                  <img src="../img/spore.png"/>
                  <span>孢子监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="4-1"  @click="selectOption(8)">实时数据</el-menu-item>
                  <el-menu-item index="4-2"  @click="selectOption(9)">图片分析</el-menu-item>
<!--                  <el-menu-item index="4-3"  @click="selectOption(10)">孢子趋势</el-menu-item>-->
                </el-menu-item-group>
              </el-submenu>

<!--              <el-menu-item index="7" >-->
<!--                <img src="../img/inse.png"/>-->
<!--                <span slot="title" >杀虫灯</span>-->
<!--              </el-menu-item>-->

              <el-submenu index="7">
                <template slot="title">
                  <img src="../img/inse.png"/>
                  <span>杀虫灯</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="7-1"  @click="selectOption(15)">实时数据</el-menu-item>
                  <el-menu-item index="7-2"  @click="selectOption(16)">历史数据</el-menu-item>
                  <el-menu-item index="7-3"  @click="selectOption(14)">指令控制</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-menu-item index="6" @click="selectOption(13)">
                <img src="../img/seed.png"/>
                <span slot="title" >苗情监测</span>
              </el-menu-item>

              <el-submenu index="8" v-if="waterFlg">
                <template slot="title">
                  <img src="../img/water.png"/>
                  <span>水肥一体机</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="8-1"  @click="selectOption(17)">数据看板</el-menu-item>
                  <el-menu-item index="8-2"  @click="selectOption(18)">设备控制</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

<!--              <el-menu-item index="7" @click="selectOption(17)" v-if="waterFlg">-->
<!--                <img src="../img/water.png"/>-->
<!--                <span slot="title" >通用水肥一体机</span>-->
<!--              </el-menu-item>-->
            </el-menu>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  //#020c28
  export default {
    name: "Left",
    components: {},
    data() {
      return {
        waterFlg: false
      }
    },

    mounted() {
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;

      if(authority != 'TENANT_ADMIN') { //非管理员用户
        this.getTotalDevice(customerId); // 获取总设备
      }
    },

    methods: {
      getTotalDevice(customerId) {
        let that = this;
        this.$MeteSoilCommon.getCustomerData(customerId, function (response) {
          for(let i = 0; i < response.data.length; i++) {
            let deviceType = response.data[i].key.toString();
            if(deviceType.indexOf('waterFlg') > -1) {
              that.waterFlg = true;
              break;
            }
          }
        })
      },

      selectOption(index) {
        this.$emit("callBackInfo", index);
      }
    }
  }
</script>

<style lang="less">
  @import "../less/Left";
</style>

<style>
  .left::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Left.vue